import { useNavigate } from 'react-router-dom';

import { Typography } from 'antd';

import BaseCard from '@/components/shared/BaseCard';
import SkeletonBaseCard from '@/components/shared/SkeletonBaseCard';
import { getCdnUrl } from '@/helpers';
import { useGetKeepWatchingShelfQuery } from '@/services/resume';
import styled, { StyledProp } from '@/styled';

import Shelf from '../../Shelf';

const KeepLearningShelf = ({ ...rest }: StyledProp) => {
  const navigate = useNavigate();
  const { data, isLoading } = useGetKeepWatchingShelfQuery('');

  if (!data?.length && !isLoading) {
    return null;
  }

  return (
    <Shelf
      title={
        <Typography.Title level={4} ellipsis>
          Continue aprendendo
        </Typography.Title>
      }
      carouselProps={{ slidesToShow: 4 }}
      {...rest}
    >
      <>
        {isLoading &&
          Array.from(Array(4).keys()).map(key => (
            <swiper-slide key={key}>
              <SkeletonBaseCard aspect='16:9' />
            </swiper-slide>
          ))}

        {data?.map(course => (
          <swiper-slide key={course.id}>
            <BaseCard
              onClick={() => navigate(`/curso/${course.hash}/aula/${course.lesson_id}`)}
              image={{
                src: getCdnUrl(course.course_newcard_background, course.image, course.old_image),
                aspect: '16:9',
                alt: course.title
              }}
              internalSpace={16}
            >
              <Typography.Paragraph ellipsis>{course.title}</Typography.Paragraph>
            </BaseCard>
          </swiper-slide>
        ))}
      </>
    </Shelf>
  );
};

export default styled(KeepLearningShelf)`
  .base-card-data {
    .ant-typography {
      margin-bottom: 0;
      color: ${({ theme }) => theme.colorTextSecondary};
    }
  }
`;
